import { MeasurementSystem } from '@seddi/core';

import type { UserPreferenceDto } from '../userSettingsDtos';
import type { UserPreferences } from '../userSettingsTypes';

export const parseUserPreferences = async (response: Response) => {
  const parsedResponse: UserPreferenceDto[] = await response.json();

  const preferences: UserPreferences = {};

  for (const field of parsedResponse) {
    let key = field.name;
    if (!/[a-z]/.test(field.name)) {
      key = field.name
        .toLowerCase()
        .replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
    }

    switch (key) {
      case 'units':
        // eslint-disable-next-line no-case-declarations
        const units =
          field.value?.toUpperCase() === 'METRIC'
            ? MeasurementSystem.Metric
            : MeasurementSystem.Imperial;
        preferences.unitSystem = units;
        break;
      case 'placementRegionGuides':
        preferences.showPlacementRegionGuides = field.value?.toLowerCase() !== 'false';
        break;
      default:
        preferences[key as 'name' | 'lastName' | 'title' | 'email' | 'displayName' | 'photoURL'] =
          field.value;
    }
  }

  return preferences;
};
